export var SocialAuthProvider;
(function (SocialAuthProvider) {
    SocialAuthProvider["Kakao"] = "KAKAO";
    SocialAuthProvider["Naver"] = "NAVER";
})(SocialAuthProvider || (SocialAuthProvider = {}));
